import { render, staticRenderFns } from "./SecretAchievement.vue?vue&type=template&id=90052f58&"
import script from "./SecretAchievement.vue?vue&type=script&lang=js&"
export * from "./SecretAchievement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports